"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowDimensions = void 0;
var react_1 = require("react");
function useWindowDimensions() {
    var hasWindow = typeof window !== 'undefined';
    function getWindowDimensions() {
        var width = hasWindow ? window.innerWidth : null;
        var height = hasWindow ? window.innerHeight : null;
        return {
            width: width,
            height: height,
        };
    }
    var _a = react_1.useState(getWindowDimensions()), windowDimensions = _a[0], setWindowDimensions = _a[1];
    react_1.useEffect(function () {
        if (hasWindow) {
            window.addEventListener('resize', function () {
                setWindowDimensions(getWindowDimensions());
            });
            return function () { return window.removeEventListener('resize', function () {
                setWindowDimensions(getWindowDimensions());
            }); };
        }
    }, [hasWindow]);
    return windowDimensions;
}
exports.useWindowDimensions = useWindowDimensions;
